import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {
  number: any;
  public name: any;
  public type: any;
  public forCheckbox:boolean=false
  groups: any;
  mapped:boolean=false;
  calendar: any;
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<AlertComponent>, protected router: Router) { }

  ngOnInit() {
    console.log("FORM ALERT", this.data);
    if (this.data.type) {
      this.number = this.data.type;
      this.name = this.data.name;
      this.calendar = this.data.calendar;
      let val = this.data.groupName;
      this.groups = val.map(obj => obj.group_name);
      console.log(this.groups, this.name);
      this.mapped = this.groups.length > 0;
    }
  }

  Close() {
    this.dialogRef.close(null);
  }

  confirmation() {
    this.dialogRef.close("yes");
  }
  custom(type:any){
    this.dialogRef.close(type);
  }

}
